
import Vue from 'vue'

export default Vue.extend({
    name: 'SiteFooter',
    components: {

    },
    data() {
        return {
           
        }
    },
    methods: {
       
    }
});
